module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "color": "primary",
      "dark": ""
    },
    slot: "activator"
  }, [_vm._v("\n    Bulk Import Export\n  ")]), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "color": "primary"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "white"
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card', [_c('v-container', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Bulk Import Export")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "href": "https://firebasestorage.googleapis.com/v0/b/engineer-ae17e.appspot.com/o/docs%2FBulk%20export%20template.xlsx?alt=media&token=69eb48b7-6a9c-46ee-911e-2926b3fff5f7"
    }
  }, [_vm._v("\n          Download Excel Template\n        ")])], 1), _vm._v(" "), _c('v-card-text', [_c('v-autocomplete', {
    attrs: {
      "items": _vm.customerList,
      "loading": _vm.gettingCustomers,
      "label": "Select a Customer",
      "item-text": "name",
      "item-value": "key",
      "required": "",
      "rules": [function (v) { return !!v || 'Customer is required'; }],
      "disabled": _vm.customerFixed
    },
    model: {
      value: (_vm.Customer),
      callback: function($$v) {
        _vm.Customer = $$v
      },
      expression: "Customer"
    }
  }), _vm._v(" "), _c('v-autocomplete', {
    attrs: {
      "label": "Project",
      "items": _vm.Projects,
      "item-text": "name",
      "item-value": "name"
    },
    model: {
      value: (_vm.Project),
      callback: function($$v) {
        _vm.Project = $$v
      },
      expression: "Project"
    }
  }), _vm._v(" "), (_vm.jobs !== null) ? [_c('v-autocomplete', {
    attrs: {
      "disabled": _vm.exported,
      "chips": "",
      "clearable": "",
      "deletable-chips": "",
      "multiple": "",
      "items": _vm.templates,
      "item-text": "name",
      "return-object": "",
      "label": "Select Devices being worked on"
    },
    model: {
      value: (_vm.selectedExportHeaders),
      callback: function($$v) {
        _vm.selectedExportHeaders = $$v
      },
      expression: "selectedExportHeaders"
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": _vm.selectedExportHeaders < 1 || _vm.Project === null
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("Export Project Data")]), _vm._v(" "), (_vm.exported) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.exported = false;
        _vm.excelInput = '';
        _vm.dataProcessed = false
      }
    }
  }, [_vm._v("\n            Reset\n          ")]) : _vm._e(), _vm._v(" "), _c('div', [_c('v-alert', {
    attrs: {
      "dismissible": "",
      "type": "success"
    },
    model: {
      value: (_vm.exported),
      callback: function($$v) {
        _vm.exported = $$v
      },
      expression: "exported"
    }
  }, [_vm._v("\n                Data Exported To Clipboard Successfully. Please make any alterations and paste data into below textbox to process.\n              ")])], 1), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "readonly": !_vm.exported,
      "id": "excelInput",
      "label": "Excel Data Input"
    },
    model: {
      value: (_vm.excelInput),
      callback: function($$v) {
        _vm.excelInput = $$v
      },
      expression: "excelInput"
    }
  }), _vm._v(" "), (_vm.exported) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Input includes header row"
    },
    model: {
      value: (_vm.includeHeaders),
      callback: function($$v) {
        _vm.includeHeaders = $$v
      },
      expression: "includeHeaders"
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.Customer || !_vm.excelInput || _vm.saving,
      "loading": _vm.processing
    },
    on: {
      "click": _vm.processRawData
    }
  }, [_vm._v("Process Data")])], 1) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.dataProcessed) ? _c('div', {
    staticClass: "mt-5"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Output Data")]), _vm._v("\n          " + _vm._s(_vm.changes.length) + " jobs have been altered\n          "), _c('v-data-table', {
    attrs: {
      "pagination": _vm.pagination,
      "hide-actions": "",
      "items": _vm.processedData,
      "headers": _vm.headers
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', [_vm._v(_vm._s(props.item.id))]), _vm._v(" "), _c('td', {
          class: {
            'green': props.item.vehReg !== _vm.jobs[props.item.id].vehReg
          }
        }, [_vm._v(_vm._s(props.item.vehReg))]), _vm._v(" "), _c('td', {
          class: {
            'green': _vm.jobs[props.item.id].templates.indexOf(props.item.type) === -1
          }
        }, [_vm._v(_vm._s(props.item.type))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.deviceType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.product))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.stockLocation))]), _vm._v(" "), _vm._l((_vm.exportHeaders), function(header) {
          return _c('td', {
            key: header.name,
            class: props.item.invalidSim && header === 'SIM' ? 'red' : props.item[header] !== 'N/A' && props.item[header] !== '' && (_vm.devices.find(function (d) { return d.type === props.item.template && d.id === props.item.uid; }) === undefined || _vm.devices.find(function (d) { return d.type === props.item.template && d.id === props.item.uid; })[header] !== props.item[header]) ? 'green' : ''
          }, [_vm._v(_vm._s(props.item[header]))])
        })], 2)]
      }
    }], null, false, 3351980615)
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "align-center": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-checkbox', {
    staticClass: "shrink",
    attrs: {
      "label": "I confirm the above output is correct"
    },
    model: {
      value: (_vm.dataLooksGood),
      callback: function($$v) {
        _vm.dataLooksGood = $$v
      },
      expression: "dataLooksGood"
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.dataLooksGood || _vm.invalidData,
      "loading": _vm.saving
    },
    on: {
      "click": _vm.saveData
    }
  }, [_vm._v("Save Vehicles")])], 1)], 1) : _vm._e()], 2)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3cd1b710","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shared/BulkImportExportDialog.vue
// module id = 743
// module chunks = 1